import React, { useCallback, useEffect, useState } from "react";
import { Tabs, Modal, Typography } from "antd";
import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";

import ClientUsers from "./clientUsers";
import UserClients from "./userClients";
import ClientUserForm from "./clientUserForm";
import TooltipButton from "../generic/tooltipButton";
import { isSuperUser } from "../../../modules/session";

const { Text } = Typography;
const { TabPane } = Tabs;

const ClientUserModal = ({ text }) => {
  const [visible, setVisible] = useState();
  const handleClose = useCallback(() => {
    setVisible();
  }, []);
  const handleShowClick = useCallback(() => {
    setVisible(true);
  }, []);

  const [show, setShow] = useState();
  const { user } = useSelector((state) => state.session);
  useEffect(() => {
    setShow(user && user.role ? isSuperUser(user.role) : false);
  }, [user]);

  return show ? (
    <>
      {text ? (
        <Text onClick={handleShowClick}>
          <FormattedMessage
            id="clientUser"
            defaultMessage="Informace klient/uživatel"
          />
        </Text>
      ) : (
        <TooltipButton
          icon="info-circle"
          text={
            <FormattedMessage
              id="clientUser"
              defaultMessage="Informace klient/uživatel"
            />
          }
          onClick={handleShowClick}
          title={
            <FormattedMessage
              id="clientUser.info"
              defaultMessage="Zobrazení informací o uživatelích klient a dostupných klientech uživatele."
            />
          }
        />
      )}
      <Modal
        width={1200}
        zIndex={999999}
        visible={visible}
        onOk={handleClose}
        onCancel={handleClose}
        cancelButtonProps={{ className: "display-none" }}
        okText={
          <FormattedMessage id="messages.close" defaultMessage="Zavřít" />
        }
      >
        <Tabs defaultActiveKey="1" animated={false}>
          <TabPane
            key="1"
            tab={
              <FormattedMessage
                id="clientUser.user"
                defaultMessage="Klienti uživatele"
              />
            }
          >
            <ClientUserForm component={UserClients} />
          </TabPane>
          <TabPane
            key="2"
            tab={
              <FormattedMessage
                id="clientUser.client"
                defaultMessage="Uživatelé klienta"
              />
            }
          >
            <ClientUserForm client component={ClientUsers} />
          </TabPane>
        </Tabs>
      </Modal>
    </>
  ) : (
    <></>
  );
};

export default ClientUserModal;
